import { menuItemsBP } from './menuItems';

/** Find an item by label across top-level items and subsections */
export const findMenuItemByLabel = (label) => {
    for (const item of menuItemsBP) {
        if (item.label === label && item.extPageId) return item;
        if (Array.isArray(item.subsections)) {
            const sub = item.subsections.find(s => s.label === label);
            if (sub) return sub;
        }
    }
    return null;
};

/** Get ordered list of Commercial App labels from your menu (fallback to hard-coded sequence) */
export const getCommercialFlow = () => {
    const commercial = menuItemsBP.find(i => i.label === 'CommercialApp');
    if (commercial?.subsections?.length) {
        return commercial.subsections.map(s => s.label);
    }
    // Fallback if the menu structure changes or isn’t loaded
    return [
        'CommercialAdditionalInfo',
        'CommercialLenderLoanInfo',
        'CommercialBorrowerInfo',
        'CommercialAssetsLiabilities',
        'CommercialGovernmentMonitoring'
    ];
};

/** Given current label, return the next label (or null if last) */
export const getNextCommercialPageLabel = (currentLabel) => {
    const flow = getCommercialFlow();
    const idx = flow.indexOf(currentLabel);
    if (idx === -1 || idx === flow.length - 1) return null;
    return flow[idx + 1];
};

/** Redirect by label (works for both top-level items and subsections) */
export const redirectToPage = async (pageLabel, loanId) => {
    const tpoAppObject = await window.elli.script.getObject('tpoApplication');
    const menuItem = findMenuItemByLabel(pageLabel);

    if (menuItem?.extPageId) {
        await tpoAppObject.pageRedirect('ExternalLoanPage', {
            id: loanId,
            extpageid: menuItem.extPageId,
            pagename: menuItem.label
        });
    } else {
        const section = pageLabel.startsWith("URLA:") ? pageLabel.split(":")[1].trim() : null;
        const redirectPage = pageLabel;

        await tpoAppObject.pageRedirect(section ? "urla" : redirectPage, {
            id: loanId,
            ...(section && { section }),
        });
    }
};
